import React, { createContext, useState, useContext, useEffect } from 'react';
import translations from '../translations';

// Create the language context
const LanguageContext = createContext();

// Custom hook to use the language context
export const useLanguage = () => {
  return useContext(LanguageContext);
};

// Language provider component
export const LanguageProvider = ({ children }) => {
  // Get the initial language from localStorage or default to 'nl'
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'nl';
  });

  // Save language to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Function to get a translation
  const t = (key, defaultText = key, replacements = {}) => {
    // If the second parameter is an object, it's the replacements (backward compatibility)
    if (typeof defaultText === 'object') {
      replacements = defaultText;
      defaultText = key;
    }
    
    const translation = translations[language][key] || defaultText;
    
    // Replace placeholders with actual values
    if (replacements && typeof replacements === 'object') {
      return Object.entries(replacements).reduce(
        (str, [key, value]) => str.replace(`{${key}}`, value),
        translation
      );
    }
    
    return translation;
  };

  // Value to be provided by the context
  const value = {
    language,
    setLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext; 